import { render } from "./AddFriendForm.vue?vue&type=template&id=8de0d68c"
import script from "./AddFriendForm.vue?vue&type=script&lang=js"
export * from "./AddFriendForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__